export interface ChecklistDisplayItem {
  id: string;
  name: string;
  status: string;
  notes: string | null;
}

export type ServiceChecklist = Record<string, ChecklistDisplayItem[]>;

export interface ChecklistItemDecision {
  status: 'OK' | 'FAIL' | null;
  wearPercent: number | null;
  doesNotApply: boolean;
  notes: string;
}

export function parseChecklistItemStatus(status: string): {
  status: ChecklistItemDecision['status'];
  wearPercent: number | null;
  doesNotApply: boolean;
} {
  const value = (status ?? '').trim().toLowerCase();

  if (!value || value === 'new') {
    return { status: null, wearPercent: null, doesNotApply: false };
  }

  if (['no aplica', 'no_aplica', 'n/a', 'na', 'not applicable'].includes(value)) {
    return { status: null, wearPercent: null, doesNotApply: true };
  }

  if (['ok', 'aprobado', 'approved', 'pass'].includes(value)) {
    return { status: 'OK', wearPercent: null, doesNotApply: false };
  }

  if (['fail', 'reprobado', 'rechazado', 'rejected', 'no'].includes(value)) {
    return { status: 'FAIL', wearPercent: null, doesNotApply: false };
  }

  const wearMatch = value.match(/(\d{1,3})/);
  if (wearMatch) {
    const wearPercent = Number(wearMatch[1]);
    if (Number.isFinite(wearPercent)) {
      return {
        status: null,
        wearPercent: Math.max(0, Math.min(100, wearPercent)),
        doesNotApply: false,
      };
    }
  }

  return { status: null, wearPercent: null, doesNotApply: false };
}

export function resolveChecklistDecisionStatus(
  decision?: ChecklistItemDecision | null,
): string | null {
  if (!decision) return null;
  if (decision.doesNotApply) return 'NO_APLICA';
  if (decision.status) return decision.status;
  if (typeof decision.wearPercent === 'number') return `${decision.wearPercent}`;
  return null;
}

export function isChecklistDecisionComplete(decision?: ChecklistItemDecision | null): boolean {
  if (!decision) return false;
  return (
    decision.status === 'OK' ||
    decision.status === 'FAIL' ||
    decision.doesNotApply === true ||
    typeof decision.wearPercent === 'number'
  );
}
